import { Flex, Text,useToast } from '@chakra-ui/react'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { getAllEmails } from '../../classes/Email'
import { AL_DELETE, AL_EDIT, AL_INFO, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { BadgeEmailType, Table, TableButtonRUDGroup, TextDateFormat } from '../shared'
import { EMAIL_ALL } from '../shared/SelectEmailTemplate'
import ModalEmailDelete from './ModalEmailDelete'
import ModalEmailEdit from './ModalEmailEdit'
import ModalEmailInfo from './ModalEmailInfo'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const TableAdminEmail = () => {
    const toast = useToast()
    const { itemData } = useSelectedItemAlertContext()
    const { userData } = useUserContext()
    const columns = useMemo(() => [
        {
            Header: '#',
            Cell: ({ row }) => (<Text>{row.index + 1}</Text>)
        },
        {
            Header: 'ชื่อแบบ',
            accessor: 'name',
        },
        {
            Header: 'หัวเรื่อง',
            accessor: 'title',
        },
        {
            Header: 'ประเภท',
            accessor: 'type',
            Cell: ({ value }) => (<BadgeEmailType type={value} />)
        },
        {
            Header: 'วันที่ปรับปรุง',
            accessor: 'updated_at',
            Cell: ({ value }) => (<TextDateFormat value={value} />)
        },
        {
            Header: 'จัดการ',
            Cell: ({ row }) => (<TableButtonRUDGroup row={row.original} disabledDelete={row.original.fix==="Y"}/>)
        },
    ], [])
    const [data, setData] = useState(null)

    const loadData = useRef()
    loadData.current = async () => {
        await getAllEmails(EMAIL_ALL, userData.token)
            .then(res => {
                setData(res)
            })
            .catch(error => {
                //console.log(error)
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        //console.log(itemData?.reload)
        loadData.current()
    }, [itemData?.reload])

    return (
        <Flex w="full">
            {data && <Table columns={columns} data={data} />}
            {itemData?.type === AL_INFO && <ModalEmailInfo data={itemData} />}
            {itemData?.type === AL_EDIT && <ModalEmailEdit data={itemData} />}
            {itemData?.type === AL_DELETE && <ModalEmailDelete data={itemData} />}
        </Flex>
    )
}

export default TableAdminEmail
